import React, { createContext, Dispatch  } from 'react';

export default createContext<{ user: { avatar?: string, firstName?: string, lastName?: string, nationalCode?: string, mobile?: string, email?: string, roles: string[], permissions: string[], complete: boolean }|null, meta: { title?: string, description?: string, host?: string, favicon?: { id: string }, horizontalLogo?: { id: string }, verticalLogo?: { id: string } }|null, accessToken: null|string, url: null|string, baseURL: null|string, dispatch: Dispatch<{ type: string, payload: object }> }>({
    user: { complete: false, permissions: [], roles: [] },
    meta: null,
    url: null,
    baseURL: null,
    accessToken: null,
    dispatch: () => {}
})
